import { usePage } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";
import Pagination from "components/shared/Pagination";
import { BookCharactersPageProps } from "./index.props";
import BookCharacterLink from "components/characters/BookCharacterLink";

function CharactersIndex() {
  const { characters } = usePage<BookCharactersPageProps>().props;
  return (
    <BookLayout>
      <Container variant="layout" size="md">
        {characters.map((bookCharacter) => (
          <BookCharacterLink
            key={bookCharacter.character.id}
            bookCharacter={bookCharacter}
          />
        ))}
        <Pagination />
      </Container>
    </BookLayout>
  );
}

CharactersIndex.layout = DefaultLayoutWrapper;
export default CharactersIndex;